var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupArrowD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "popup-arrow",
    viewBox: "0 0 10 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#052334",
    points: "0 0 10 0 5 20 0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupArrowD);
export default __webpack_public_path__ + "static/media/popup-arrow-d.6dfa306cc23767b43915856583936daa.svg";
export { ForwardRef as ReactComponent };